import React, {PureComponent} from "react"
import styled from "styled-components"

import {Label} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

interface Props {
  enabled: boolean
}

const StyledLabel = styled(Label)<Props>`
  height: 21px;
  border-radius: 5px;
  padding: 5px 8px;
  color: ${({theme}) => theme.colors.greys.white};
  background-color: ${({enabled, theme}) => enabled
    ? theme.colors.tertiary.g_400
    : theme.colors.utility.subdued};
`

class EnabledDisabledLabel extends PureComponent<Props> {
  render() {
    const {enabled} = this.props
    return <StyledLabel enabled={enabled}>
      {enabled
        ? <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.enabled" />
        : <FormattedMessage id="admin.containers.integrations.enabledDisabledLabel.disabled" />}
    </StyledLabel>
  }
}

export default EnabledDisabledLabel
